import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

/**
 * The way out of auditor preview — all this file still owns.
 *
 * It used to also export `ADMIN_AUDITOR_VIEW_HEADER_CLASS` (which tinted the
 * page header `#FFF8E0`), `AdminAuditorViewNotice` (the header-trailing form)
 * and, briefly, `AdminAuditorViewTopBanner`. All three are gone: the banner is
 * `ViewModeBanner` now, rendered once above the sidebar for every
 * borrowed-identity mode, and surfaces publish to it instead of styling their
 * own header.
 */
interface AdminAuditorViewExitLinkProps {
  workspaceId: string
  auditCycleId: string
}

export function AdminAuditorViewExitLink({
  workspaceId,
  auditCycleId,
}: AdminAuditorViewExitLinkProps) {
  return (
    <Link
      to='/workspaces/$workspaceId/audits/$auditCycleId'
      params={{ workspaceId, auditCycleId }}
      preload={false}
      className='inline-flex shrink-0 items-center gap-1.5 text-[13px] font-medium text-status-orange transition-colors hover:text-status-orange'
    >
      <ArrowLeft className='h-3.5 w-3.5' />
      Exit auditor view
    </Link>
  )
}
